import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "form",
  id: "bind-mobile-form"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { computed, ref } from "vue";
import { ElMessage } from "element-plus";
import { httpPost } from "@/utils/http";
import { showMessageError, showMessageOK } from "@/utils/dialog";
export default {
  __name: 'RedeemVerify',
  props: {
    show: Boolean
  },
  emits: ['hide'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const showDialog = computed(() => {
      return props.show;
    });
    const title = ref('兑换码核销');
    const form = ref({
      code: ''
    });
    const emits = __emit;
    const save = () => {
      if (form.value.code === '') {
        return ElMessage.error({
          message: "请输入兑换码"
        });
      }
      httpPost('/api/redeem/verify', form.value).then(() => {
        showMessageOK("兑换成功！");
        emits('hide', true);
      }).catch(e => {
        showMessageError("兑换失败：" + e.message);
      });
    };
    const close = function () {
      emits('hide', false);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showDialog.value = $event),
        "close-on-click-modal": true,
        "before-close": close,
        width: 450,
        title: title.value
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 立即兑换 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          model: form.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.code = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};